// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper[data-v-8d2f200a] {
  height: auto;
  font-size: 16px;
  font-weight: 500;
}
.tabs[data-v-8d2f200a] {
  position: relative;
  color: var(--toolbtn-color);
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  border-radius: var(--tabs-border-radius);
  border: var(--tabs-border);
  border-color: var(--custom-tab-border);
  justify-content: space-around;
}
.tabs div.option[data-v-8d2f200a] {
  height: 1.6em;
  width: var(--tab-width);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition-property: all;
  transition-duration: .25s;
}
.tabs div.option[data-v-8d2f200a]:first-child {
  margin-right: 0.2em;
}
.tabs div.option[data-v-8d2f200a]:hover {
  border-radius: 20px;
  background: var(--custom-tab-hover);
}
.active[data-v-8d2f200a] {
  background-color: var(--custom-tab-activebg);
  border: 1px solid var(--custom-tab-activeorder);
  border-radius: 20px;
}
.rail[data-v-8d2f200a] {
  height: 1px;
  border-bottom: 1px solid var(--search-rail-border);
  position: relative;
  width: 100%;
  z-index: 100;
}
.rail .line-wrapper[data-v-8d2f200a] {
  position: absolute;
  margin-top: -1px;
  width: var(--tab-width);
  transition-property: all;
  transition-duration: .5s;
}
.rail .line-wrapper .line[data-v-8d2f200a] {
  height: 2px;
  background-color: var(--blue-bgcolor);
  margin: auto;
  width: var(--tab-width);
}
.rail .line-wrapper.chosenTab0[data-v-8d2f200a] {
  margin-left: var(--marginLeft0);
  transition-property: all;
  transition-duration: .25s;
}
.rail .line-wrapper.chosenTab1[data-v-8d2f200a] {
  margin-left: var(--marginLeft1);
  transition-property: all;
  transition-duration: .25s;
}
.rail .line-wrapper.chosenTab2[data-v-8d2f200a] {
  margin-left: var(--marginLeft2);
  transition-property: all;
  transition-duration: .25s;
}
.rail .line-wrapper.chosenTab3[data-v-8d2f200a] {
  margin-left: var(--marginLeft3);
  transition-property: all;
  transition-duration: .25s;
}
.rail .line-wrapper.chosenTab4[data-v-8d2f200a] {
  margin-left: var(--marginLeft4);
  transition-property: all;
  transition-duration: .25s;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/custom/CustomTabs.vue"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,sCAAsC;EACtC,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,4CAA4C;EAC5C,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kDAAkD;EAClD,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAyB;AAC3B","sourcesContent":[".wrapper[data-v-8d2f200a] {\n  height: auto;\n  font-size: 16px;\n  font-weight: 500;\n}\n.tabs[data-v-8d2f200a] {\n  position: relative;\n  color: var(--toolbtn-color);\n  height: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  border-radius: var(--tabs-border-radius);\n  border: var(--tabs-border);\n  border-color: var(--custom-tab-border);\n  justify-content: space-around;\n}\n.tabs div.option[data-v-8d2f200a] {\n  height: 1.6em;\n  width: var(--tab-width);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition-property: all;\n  transition-duration: .25s;\n}\n.tabs div.option[data-v-8d2f200a]:first-child {\n  margin-right: 0.2em;\n}\n.tabs div.option[data-v-8d2f200a]:hover {\n  border-radius: 20px;\n  background: var(--custom-tab-hover);\n}\n.active[data-v-8d2f200a] {\n  background-color: var(--custom-tab-activebg);\n  border: 1px solid var(--custom-tab-activeorder);\n  border-radius: 20px;\n}\n.rail[data-v-8d2f200a] {\n  height: 1px;\n  border-bottom: 1px solid var(--search-rail-border);\n  position: relative;\n  width: 100%;\n  z-index: 100;\n}\n.rail .line-wrapper[data-v-8d2f200a] {\n  position: absolute;\n  margin-top: -1px;\n  width: var(--tab-width);\n  transition-property: all;\n  transition-duration: .5s;\n}\n.rail .line-wrapper .line[data-v-8d2f200a] {\n  height: 2px;\n  background-color: var(--blue-bgcolor);\n  margin: auto;\n  width: var(--tab-width);\n}\n.rail .line-wrapper.chosenTab0[data-v-8d2f200a] {\n  margin-left: var(--marginLeft0);\n  transition-property: all;\n  transition-duration: .25s;\n}\n.rail .line-wrapper.chosenTab1[data-v-8d2f200a] {\n  margin-left: var(--marginLeft1);\n  transition-property: all;\n  transition-duration: .25s;\n}\n.rail .line-wrapper.chosenTab2[data-v-8d2f200a] {\n  margin-left: var(--marginLeft2);\n  transition-property: all;\n  transition-duration: .25s;\n}\n.rail .line-wrapper.chosenTab3[data-v-8d2f200a] {\n  margin-left: var(--marginLeft3);\n  transition-property: all;\n  transition-duration: .25s;\n}\n.rail .line-wrapper.chosenTab4[data-v-8d2f200a] {\n  margin-left: var(--marginLeft4);\n  transition-property: all;\n  transition-duration: .25s;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
